import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../../css/entry.css";
import SriyanshCardHeader from "../../components/CardHeader";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import dayjs from "dayjs";
import EncryptService from "../../service/EncryptionService";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import ListHeaderTableComponent from "../../CustomComponant/ListHeaderTables";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";

function COSGEntry() {
  const navigate = useNavigate();
  const { state } = useLocation();

  let poNumberFromList = state.expponumber;
  let billNumberFromList = state.expbillnumber;

  const [returnData, setreturnData] = useState([]);
  const [cosReturnData, setCOSReturnData] = useState([]);
  const [cosReceiptDate, setcosReceiptDate] = useState(null);
  const [billPassingDate, setbillPassingDate] = useState(null);
  const [errors, setErrors] = useState({});

  const today = dayjs();
  //const [error, setError] = useState("");
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));
  const handleClose = () => {
    navigate("../cosglist", { replace: true });
    // console.log(!cosReturnData);
  };

  const InsertPOData = async (e) => {
    e.preventDefault();
    let formErrors = {};

    if (!cosReceiptDate) {
      formErrors.billRdateerror = "Invalid Receiving Date";
    }
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const cosdt = new Date(cosReceiptDate);
      const cosreceiptdt =
        cosdt.getFullYear() +
        "/" +
        parseInt(cosdt.getMonth() + 1) +
        "/" +
        cosdt.getDate();

      const billdt = new Date(billPassingDate);
      const billPassdt =
        billdt.getFullYear() +
        "/" +
        parseInt(billdt.getMonth() + 1) +
        "/" +
        billdt.getDate();

      apiClient
        .post("/COSEntry", {
          vponumber: poNumberFromList,
          vbillnumber: billNumberFromList + " ",
          vbillreceivingdate: cosreceiptdt,
          // vbillpassingdate: billPassdt,
          ventryuser: uname,
          vip: ip,
        })
        .then(function (response) {
          //setError(response.data);
          navigate("../cosglist", { replace: true });
        })
        .catch(function (error) {
          // setsrcData([]);
          alert(error);
        });
    }
  };

  const UpdateBillPassingDate = async (e) => {
    //console.log("dfgd");
    e.preventDefault();
    let formErrors = {};

    if (!billPassingDate) {
      formErrors.billPdateerror = "Invalid PassingDate";
    }
    if (!cosReceiptDate) {
      formErrors.billRdateerror = "Invalid Receiving Date";
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const billdt = new Date(billPassingDate);
      const billPassdt =
        billdt.getFullYear() +
        "/" +
        parseInt(billdt.getMonth() + 1) +
        "/" +
        billdt.getDate();

      apiClient
        .post("/COSUpdate", {
          vponumber: poNumberFromList,
          vbillnumber: billNumberFromList + " ",
          vbillpassingdate: billPassdt,
          ventryuser: uname,
          vip: ip,
        })
        .then(function (response) {
          // setError(response.data);
          navigate("../cosglist", { replace: true });
        })
        .catch(function (error) {
          // setsrcData([]);
          alert(error);
        });
    }
  };

  const getdata = async (e) => {
    apiClient
      .post("/podetailscos", {
        uname: uname,
        poNumber: poNumberFromList + " ",
        billnumber: billNumberFromList + " ",
      })
      .then(function (response) {
        setreturnData(response.data[0]);
        // getCOSGdata();
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const getCOSGdata = async (e) => {
    try {
      const response11 = await apiClient.post("/cosgData_ByBillnumber", {
        uname: uname,
        poNumber: poNumberFromList + " ",
        billnumber: billNumberFromList + " ",
      });
      // Check if response.data exists and is not empty
      if (response11.data && response11.data.length > 0) {
        setCOSReturnData(response11.data);
        setcosReceiptDate(dayjs(response11.data[0].billreceivingdate));
        // Set first element of the data
      } else {
        // Throw an error if no data is found
        // throw new Error("Data not found for the provided bill number");
        // setCOSReturnData([]);
      }
    } catch (error) {
      // Handle and set the error in state
      //setError(error.message);
      ///setCOSReturnData([]); // Optionally clear data if there is an error
    }
  };

  //console.log (cosReturnData);

  useEffect(() => {
    getdata();
    getCOSGdata();
    // cosReturnData && setcosReceiptDate(cosReturnData.billreceivingdate);
  }, []);

  const headers = [
    ["Indent Number", "PO Number", "Consignee"],
    ["Item Name", "Bill Number", "Bill Date"],
    ["Billed Item Qty", "Billed Value", "Paymenttype"],
  ];

  //
  const rows = [
    [returnData.IndentNumber, returnData.ponumber, returnData.POConsignee],
    [returnData.POItemName, returnData.billnumber, returnData.billdate],
    [
      returnData.billitemQty,
      returnData.billitemValue,
      returnData.paymentDesription,
    ],
  ];

  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

  return (
    <div>
      <Card className="Formcard">
        <div className="input-groupHeading">
          Bill/Invoice Receiving and Passing Date Entry
        </div>
        
          <CardContent>
            <Accordion defaultExpanded>
              <AccordionSummary
                expandIcon={<ArrowDownwardIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Typography component="span" variant="h6">
                  PO Details
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <ListHeaderTableComponent headers={headers} rows={rows} />
              </AccordionDetails>
            </Accordion>

          
            <div className="container">
              <div className="input-group">
                <DatePickerComponent
                  label="Bill/Invoice Receiving Date"
                  id="cosReceiptDate"
                  value={cosReceiptDate}
                  //onChange={}
                  onChange={(newDate) =>
                    handleDateChange(newDate, setcosReceiptDate)
                  }


                  error={errors.billRdateerror}
                  maxDate={today}
                  //minDate={minCalDate}
                  minDate={
                    returnData.billdate ? dayjs(returnData.billdate) : dayjs()
                  }
                  disabled={(cosReturnData.length>0)}
                />
              </div>

              <div className="input-group">
                <DatePickerComponent
                  label="Bill/Invoice Passing  Date"
                  id="billPassingDate"
                  value={billPassingDate}
                 
                  onChange={(newDate) =>
                    handleDateChange(newDate, setbillPassingDate)
                  }
                 
                  error={errors.billPdateerror}
                 
                  maxDate={today}
                  minDate={
                    cosReturnData && cosReturnData.length > 0 && cosReturnData[0].billreceivingdate 
                      ? dayjs(cosReturnData[0].billreceivingdate) 
                      : dayjs()
                  }
                  disabled={!(cosReturnData.length>0)}
                  // minDate={minCalDate}
                />
              </div>
            </div>
         
           
          
            <div
              className="flex container"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={InsertPOData}
                title="Click for Data Save"
                disabled={(cosReturnData.length>0)}
                
              >
                Save Data
              </button>



              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
               onClick={UpdateBillPassingDate}
                title="Click for Data Proceed"
                style={{ backgroundColor: "navy", color: "white" }}
               disabled={!(cosReturnData.length>0)}
              >
                Proceed Data
              </button> 





              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Click for Data Save"
                style={{ backgroundColor: "red", color: "white" }}
                
              >
                Close
              </button>
            </div>
          
         

          </CardContent>
       
      </Card>
    </div>
  );
}

export default COSGEntry;
